var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-class"},[(_vm.list && _vm.list.length)?_c('ul',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},_vm._l((_vm.list),function(item){return _c(_vm.comName,{key:item.id,tag:"Component",attrs:{"info":item}})}),1):_c('Empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }